/** Keep polling independent of slide playback, including after a stalled connection. */
export function startDisplaySync<T>(fetchPayload: (signal: AbortSignal) => Promise<T>, apply: (payload: T) => void, intervalMs = 10_000, timeoutMs = 8_000) {
  let stopped = false;
  let active: AbortController | null = null;
  const refresh = async () => {
    if (stopped || active) return;
    const controller = new AbortController();
    active = controller;
    const timeout = setTimeout(() => {
      controller.abort();
      if (active === controller) active = null;
    }, timeoutMs);
    try {
      const payload = await fetchPayload(controller.signal);
      if (!stopped && !controller.signal.aborted) apply(payload);
    } catch {
      // Continue the last-known playlist and retry on the next tick.
    } finally {
      clearTimeout(timeout);
      if (active === controller) active = null;
    }
  };
  void refresh();
  const poll = setInterval(() => void refresh(), intervalMs);
  return {
    refresh,
    stop() {
      stopped = true;
      clearInterval(poll);
      active?.abort();
      active = null;
    }
  };
}
